module.exports = __webpack_public_path__ + "static/media/rikTorfs.afdbce4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/rikTorfs.jpg
// module id = 1584
// module chunks = 1